<template>
  <div class="contact-us-blurb">
    <!-- Tab -->
    <div
      class="tab"
      @click="is_showing_contact_modal = true"
    >
      <div class="icon">
        <i class="fas fa-comment-dots" />
      </div>
      <div class="text">
        <div class="title">
          Need Assistance?
        </div>
        <div class="link">
          Contact Us
        </div>
      </div>
    </div>

    <!-- Contact Us Modal -->
    <form
      v-show="is_showing_contact_modal"
      class="fff-modal contact-us-modal"
      @submit.prevent="submit_suggest_food"
    >
      <div
        class="overlay"
        @click="is_showing_contact_modal = false"
      />
      <div class="box">
        <div
          class="close-modal"
          @click="is_showing_contact_modal = false"
        >
          &times;
        </div>
        <h2>Get Support / Contact Us</h2>
        <p>Reach out - let us know how we can help!</p>
        <div class="field">
          <textarea
            v-model="contact_data.message"
            name="name"
            rows="8"
            class="fff-ui"
            placeholder="Write here..."
          />
        </div>
        <div class="field">
          <label>Please respond via</label>
          <label class="inline-radio">
            <span class="primary-input"><input
              v-model="contact_data.response_type"
              type="radio"
              name="response_type"
              value="phone"
            ></span>
            <span class="label">Phone</span>
            <span
              class="secondary-input"
              :style="{opacity: (contact_data.response_type == 'phone' ? 1 : 0)}"
            ><input
              v-model="contact_data.phone"
              type="text"
              class="fff-ui"
              placeholder="(555) 555-5555"
            ></span>
          </label>
          <label class="inline-radio">
            <span class="primary-input"><input
              v-model="contact_data.response_type"
              type="radio"
              name="response_type"
              value="email"
            ></span>
            <span class="label">Email</span>
            <span
              class="secondary-input"
              :style="{opacity: (contact_data.response_type == 'email' ? 1 : 0)}"
            ><input
              v-model="contact_data.email"
              type="text"
              class="fff-ui"
              placeholder="hello@example.com"
            ></span>
          </label>
        </div>
        <div class="button-container fluid">
          <button
            type="submit"
            class="button fluid"
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      is_showing_contact_modal: false,
      contact_data: {
        message: '',
        response_type: 'phone',
        phone: '',
        email: '',
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.tab {
	position: fixed;
	bottom: 48px;
	right: 0;
	padding: 8px 24px;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #333;
	color: #fff;
	border-radius: 1000px 0 0 1000px;
	font-size: 12px;
	cursor: pointer;
	transition: all 0.2s ease;
	z-index: 9999;
}
.tab:not(:hover) {
	transform: translateX(calc(100% - 64px));
}
.tab .icon {
	font-size: 24px;
	margin-right: 24px;
}
.tab .link {
	font-weight: 700;
}
</style>